import React from "react";
import {Card,CardBody,Row,Col} from "reactstrap";
import ReviewsData from "./ReviewsData";
const ReviewsNumbers = () =>{
    return(
        
            <Card className="mt-4 pl-4">
                <CardBody className=" py-1 pl-4">
                    <Row>
                    {
                        ReviewsData.map(review=>{
                            return(
                                <Col lg="3" md="6" key={review.id} className="align-contents-center pr-3 ">
                                    <p className="mb-1 mt-3 reviewNumber font-weight-bold">{review.noOfReviews}</p>
                                    <p className="reviewDetail">{review.details}</p>
                                </Col>
                            )
                        })
                    }
                    </Row>
                </CardBody>
            </Card>
        
    )
}
export default ReviewsNumbers;